import { render, staticRenderFns } from "./ExampleComponent.vue?vue&type=template&id=c32d1468&scoped=true&"
import script from "./ExampleComponent.vue?vue&type=script&lang=js&"
export * from "./ExampleComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExampleComponent.vue?vue&type=style&index=0&id=c32d1468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32d1468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\simec\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c32d1468')) {
      api.createRecord('c32d1468', component.options)
    } else {
      api.reload('c32d1468', component.options)
    }
    module.hot.accept("./ExampleComponent.vue?vue&type=template&id=c32d1468&scoped=true&", function () {
      api.rerender('c32d1468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/ExampleComponent.vue"
export default component.exports